import { render } from "./Stk-Modal.vue?vue&type=template&id=49602a3b"
import script from "./Stk-Modal.vue?vue&type=script&lang=js"
export * from "./Stk-Modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__